import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { ModalDynamicComponent } from './modal-dynamic.component';

@NgModule({
  declarations: [ModalDynamicComponent],
  imports: [CommonModule, AngularSvgIconModule],
  exports: [ModalDynamicComponent],
})
export class ModalDynamicModule {}
